export default {
    generic: {
      missing: 'Please provide the required field',
      invalid: 'The value you have provided is invalid',
    },
    name: {
      title: {
        missing: 'Please Provide a Name for the session',
        rule: {
            matches: 'The passwords do not match',
        },
      },
      board_id: {
        missing: 'Please Choose or Add A Board Model',
        rule: {
            matches: 'The passwords do not match',
        },
      },
    },
  }